<div class="main-container">
    <div class="score-tooltip-drilldownChart" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
      <div class="tooltipHeading">{{event.label}}</div>
      <div>
        <div class="caret" *ngFor="let dataPoint of event?.dataPoints; let last = last" [ngClass]="{'border-bottom': !last}">
          <div class="tooltipLabel">{{ dataPoint.label }}</div> 
          <div class="tooltipValue">
            {{ (dataPoint?.value?.y !== null && dataPoint?.value?.y !== undefined)?dataPoint?.value?.y:(dataPoint?.value !== null && dataPoint?.value !== undefined)?dataPoint?.value:"NA" }}
          </div> 
        </div>
      </div>
    </div>
    <div class="chart-container" #chartContainer>
      <div class="colSmall">
        <canvas [id]="axisChartId" height="100%"></canvas>
      </div>
      <div class="colLarge" [id]="boxId">
        <div class="box" [style.width]="calcWidth()">
          <canvas [id]="mainChartId" height="100%"></canvas>
        </div>
      </div>
    </div>
    <div class="custom-legend-container" [style.margin-top]="legendTop">
      <div class="cohort-labels">{{ xText }}</div>
      <div class="custom-legend">
        <div class="custom-legend-item" *ngFor="let dataset of data.datasets; let i = index" (click)="toggleDatasetVisibility(i)" [ngClass]="{
          'selected': selectedDatasetIndex === i,
          'deselected': selectedDatasetIndex !== null && selectedDatasetIndex !== i,
          'underlined': selectedDatasetIndex === null
        }"
        [style.cursor]="data.datasets.length > 1 ? 'pointer' : 'default'">
          <div class="color-box" [style.background-color]="dataset.backgroundColor"></div>
          <div class="label" [ngClass]="{
            'selected': selectedDatasetIndex === i,
            'deselected': selectedDatasetIndex !== null && selectedDatasetIndex !== i,
            'underlined': selectedDatasetIndex === null
          }">{{ dataset.label }}</div>
        </div>
      </div>
    </div>
  </div>